/** Стандартные классы для input в формах (DaisyUI) */
export const INPUT_CLASSES = 'input input-bordered input-md w-full';

/** Стандартные классы для textarea в формах (DaisyUI) */
export const TEXTAREA_CLASSES = 'textarea textarea-bordered textarea-md w-full';

/** Стандартные классы для select в формах (DaisyUI) */
export const SELECT_CLASSES = 'select select-bordered select-md w-full';

/** Чекбоксы: скругление 4px, видимая граница (контраст с фоном) */
export const CHECKBOX_CLASSES = 'checkbox checkbox-sm rounded-[4px] border-2 border-base-content/55';
